import { Fragment, useEffect, useState } from "react";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import SidebarItems from "./SidebarItems";
import style from "./SidebarSmall.module.css";

function SidebarSmall() {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    setCollapsed(() => false);
  }, [location.pathname]);

  return (
    <Fragment>
      {collapsed === false && (
        <button
          className={style.showArrow}
          onClick={() => setCollapsed(cur => !cur)}
        >
          <span>نمایش منو</span>
          <span>
            <FiChevronsLeft />
          </span>
        </button>
      )}

      <div
        className={[style.sidebar, collapsed ? style.sidebarActive : ""].join(
          " "
        )}
      >
        <button className="d-lg-none" onClick={() => setCollapsed(cur => !cur)}>
          <span>بستن منو</span>
          <span className="me-3">
            <FiChevronsRight />
          </span>
        </button>
        <SidebarItems />
      </div>
    </Fragment>
  );
}

export default SidebarSmall;
